import { join } from '../pathname/join.js';

function withCtxMatch() {
  return async ctx => {
    // Supply a partial deprecated backwards compatible shim for bonnet@<10
    // usage react-router's match object added to the initial ctx object
    ctx.match = {
      ...ctx.match,
      url: join(process.env.BASE_PATH, ctx.asPath).split('?')[0]
    };
    ctx.registerMiddleware('match');
  };
}

export { withCtxMatch };
